import { render, staticRenderFns } from "./SettingSection.vue?vue&type=template&id=2c7cd4be&scoped=true&"
import script from "./SettingSection.vue?vue&type=script&lang=js&"
export * from "./SettingSection.vue?vue&type=script&lang=js&"
import style0 from "./SettingSection.vue?vue&type=style&index=0&id=2c7cd4be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7cd4be",
  null
  
)

export default component.exports